export default {
  isDisabledDevice() {

    if(this.mobile() || this.internetEplorer11()) {
      return true;
    }

  },
  mobile() {
    var Android = navigator.userAgent.match(/Android/i);

    var BlackBerry = navigator.userAgent.match(/BlackBerry/i);

    var iOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);

    var Opera = navigator.userAgent.match(/Opera Mini/i);

    var Windows = navigator.userAgent.match(/IEMobile/i);

    return (Android || BlackBerry || iOS || Opera || Windows);

  },

  internetEplorer11() {
    if(navigator.userAgent.indexOf('MSIE')!==-1
    || navigator.appVersion.indexOf('Trident/') > -1){
      return true;
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/disable-animation-for-devices.js